export enum AutoriteFourriereSortOptions {
  'ACTIONS_REQUISES' = 'ACTIONS_REQUISES',
  'CLASSEMENT' = 'CLASSEMENT',
  'FOURRIERE' = 'FOURRIERE',
  'DATE_BON_ENLEVEMENT' = 'DATE_BON_ENLEVEMENT',
  'DATE_MISE_FOURRIERE' = 'DATE_MISE_FOURRIERE',
  'DATE_SORTIE_DEFINITIVE' = 'DATE_SORTIE_DEFINITIVE',
  'IMMATRICULATION' = 'IMMATRICULATION',
  'NATURE_MISE_EN_FOURRIERE' = 'NATURE_MISE_EN_FOURRIERE',
  'STATUT' = 'STATUT',
  'DATE_ORDRE_DESTRUCTION' = 'DATE_ORDRE_DESTRUCTION',
}
